import { DistributionType } from '../../enums/distribution-type';

export class DistributionAddress {
    public addressId: string;
    public visited: boolean;
    public distributionType: DistributionType;

    constructor();
    constructor(json: any)
    constructor(json?: DistributionAddress) {
        if (json) {
            this.addressId = json.addressId;
            this.visited = json.visited;
            this.distributionType = json.distributionType;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/models/distribution/distribution-address.ts